// React imports
import React from 'react';

// Styles
import styles from './ServiceCategorySkeleton.module.scss';

export const ServiceCategorySkeleton: React.FC = () => {
    return (
        <div className={styles.skeleton}>
            <div className={styles.checkboxSkeleton}></div>
            <div className={styles.textSkeleton}></div>
        </div>
    );
};
